import {CampoAggiuntivo, Sezione} from "../../../app/shared/models/campo-aggiuntivo";
import {ApiPathsService} from "../../../app/api-paths.service";
import {FieldViewerComponent} from "../../../app/shared/field-viewer/field-viewer.component";
import {isAgente, isDM, isNAM, RuoliAccesso, RuoliAccessoObject, RuoliOperativi} from "./SanPellegrino";
import {generateExcel, randomString} from "../../Utility/Utility";
import {ToastrService} from "ngx-toastr";
import * as XLSX from 'xlsx';
import {forkJoin} from "rxjs";

function TabellaDM_NAM(Title: string, Ruolo: "DM" | "NAM" | "Agente"): CampoAggiuntivo {
  return CampoAggiuntivo.TableField(
    Title,
    [
      CampoAggiuntivo.InputField("Nome", "nome", 'text', 'col-lg-12', {required: true}),
      CampoAggiuntivo.InputField("Cognome", "cognome", 'text', 'col-lg-12', {required: true}),
      CampoAggiuntivo.InputField("E-mail", "email", "email", "col-lg-12", {modificabile: true, required: true}),

      ...(Ruolo == "Agente" ? [CampoAggiuntivo.SingleDropdown("DM", 'dm', 'referenti', 'fullName', {
        required: true,
        modificabile: true,
        sourceFilter: {
          func: (x, Oggetto, permission) => {
            return isDM(x.ruoliAccessoObject) != undefined
          }
        }
      }, "col-lg-12", () => true, {
        singleOutput: false,
        singleSelection: false
      })] : [])
      //CampoAggiuntivo.SingleDropdown("Ruolo", "ruoli",RuoliOperativiRef,"label", {},'col-lg-12',()=>true, {singleOutput:false}),
    ],
    "referenti",
    true,
    "col-lg-12",
    {
      filter: (ref: any[]) => ref.filter(y => {
          switch (Ruolo) {
            case 'DM':
              return isDM(y.ruoliAccessoObject)
            case 'NAM':
              return isNAM(y.ruoliAccessoObject)
            case 'Agente':
              return isAgente(y.ruoliAccessoObject)
            default:
              return false;
          }
        }
      ).map(x => {
        x.ruoli = RuoliOperativi(x.ruoliAccessoObject);
        return x
      }),
      Buttons: [
        {
          nome: '',
          close: false,
          Label: "Aggiungi",
          icon: 'fas fa-plus text-info',
          class: 'btn',
          labelClass: 'text-info font-weight-bold',
          type: 'func',
          func: (x: { referenti: any[], id: number }, api: ApiPathsService, endFunc) => {
            x.referenti.push({
              ruoliAccesso: RuoliAccesso(Ruolo),
              principale: false,
              ruoliAccessoObject: RuoliAccessoObject(Ruolo),
              ruoli: [Ruolo],
              cliente: x.id
            })

          },
          validate: () => true,
        },
        {
          nome: '',//Nome	Cognome	Tipo	Email	DM(/separated)
          icon: 'fas fa-download text-info',
          class: 'btn',
          tooltip: "Scarica il template",
          labelClass: 'text-info font-weight-bold',
          func: () => {
            generateExcel([['Nome','Cognome','Tipo','Email','DM'], ['<nome>','<cognome>','<tipo (DM, NAM, Agente) >','<email>','<DM separati dal carattere / "COGNOME NOME">'],], "Template import utenti")
          }
        },
        {
          nome: '',//Nome	Cognome	Tipo	Email	DM(/separated)
          icon: 'fas fa-upload text-info',
          class: 'btn',
          tooltip: "importa utenti",
          labelClass: 'text-info font-weight-bold',
          func: (Cliente: any, api: ApiPathsService, end: () => void, toastService: ToastrService) => {
            const input = document.createElement('input');
            input.type = 'file';
            input.onchange = async () => {
              const file = input.files?.[0];
              if (!file) {
                toastService.error('Nessun file selezionato');
                return;
              }
              const data = await file.arrayBuffer();
              const workbook = XLSX.read(data, {type: 'array'});
              const firstSheetName = workbook.SheetNames[0];
              const worksheet = workbook.Sheets[firstSheetName];
              const excelData: {
                Nome: string,
                Cognome: string,
                Tipo: "Agente" | "DM" | "NAM" | "Super user",
                Email: string,
                DM: string
              }[] = XLSX.utils.sheet_to_json(worksheet, {raw: true});



              function CreateNams(){
                var nam = excelData.filter(x => x.Tipo == "NAM").map(x => {

                  return {
                    ...x,
                    nome: x.Nome,
                    cognome: x.Cognome,
                    email: x.Email,
                    ruoliAccesso: RuoliAccesso("NAM"),
                    principale: false,
                    ruoliAccessoObject: RuoliAccessoObject("NAM"),
                    ruoli: ["NAM"],
                    cliente: Cliente.id,
                    id: Cliente.referenti.find(y => y.nome == x.Nome && y.cognome == x.Cognome)?.id
                  }
                });
                var requests = nam.filter(x=>!x.id ).map(agente => api.ClassicPost(`/anagrafica/clienti/referenti/add`, agente))
                forkJoin(requests).subscribe(data => {
                  var agentiWithIDS = [...nam.filter(x=>x.id), ...data];
                  Cliente.referenti = [...Cliente.referenti, ...data]

                })


              }
              function CreateAgent(Dms){
                var agenti = excelData.filter(x => x.Tipo == "Agente").map(x => {
                  var dmStrings = x?.DM?.split('/') ?? [];
                  var dm = dmStrings.map(x => {
                    return Dms.find(y => `${y.cognome} ${y.nome}` == x);
                  }).filter(x=>x);
                  return {
                    ...x,
                    dmStrings,
                    dmObject: dm,
                    dm: dm.map(a=>a.id),
                    nome: x.Nome,
                    cognome: x.Cognome,
                    email: x.Email,
                    ruoliAccesso: RuoliAccesso("Agente"),
                    principale: false,
                    ruoliAccessoObject: RuoliAccessoObject("Agente"),
                    username : x.Email,
                    password : randomString(10),
                    ruoli: ["AG"],
                    cliente: Cliente.id,
                    id: Cliente.referenti.find(y => y.nome == x.Nome && y.cognome == x.Cognome)?.id
                  }
                });
                console.log("Agenti To Send: ", agenti.filter(x=>!x.id && x.dm?.length))
                var requests = agenti.filter(x=>!x.id && x.dm?.length).map(agente => api.ClassicPost(`/anagrafica/clienti/referenti/add`, agente))
                forkJoin(requests).subscribe(data => {
                  var agentiWithIDS = [...agenti.filter(x=>x.id), ...data];
                  Cliente.referenti = [...Cliente.referenti, ...data]

                })
              }
              function CreateNamAndAgent(){
                var DMStructured = excelData.filter(x => x.Tipo == "DM").map(x => {

                  return {
                    ...x,
                    nome: x.Nome,
                    cognome: x.Cognome,
                    email: x.Email,
                    ruoliAccesso: RuoliAccesso("DM"),
                    principale: false,
                    ruoliAccessoObject: RuoliAccessoObject("DM"),
                    ruoli: ["DM"],
                    cliente: Cliente.id,
                    id: Cliente.referenti.find(y => y.nome == x.Nome && y.cognome == x.Cognome)?.id
                  }
                })
                var requests = DMStructured.filter(x=>!x.id).map(dm => api.ClassicPost(`/anagrafica/clienti/referenti/add`, dm))
                if (requests?.length)
                  forkJoin(requests).subscribe(data => {
                    var dmWithIDS = [...DMStructured.filter(x=>x.id), ...data];
                    Cliente.referenti = [...Cliente.referenti, ...data]
                    console.log("dmWithIDS", dmWithIDS);
                    CreateAgent(dmWithIDS);
                  })
                else
                  CreateAgent(DMStructured.filter(x=>x.id))
              }
              CreateNamAndAgent()
              CreateNams();
            };
            input.click();
          }
        },

      ],
      azioni: [
        {label: "Salva", nome: "salva", icon: "fas fa-save", color: "blue", func: saveRef},
        {
          icon: "fas fa-key",
          tooltip: "Genera Credenziali",
          color: "blue",
          hideif: {func: (x) => x.id},
          func: (field, bottone, campo, Oggetto, api: ApiPathsService, component: FieldViewerComponent) => {
            console.log("Genera Credenziali", {field, bottone, campo, Oggetto});
            field.username = field.email;
            field.password = randomString(10);
            saveRef(field, bottone, campo, Oggetto, api, () => {
              api.ClassicPost('/anagrafica/clienti/referenti/email', {ids: [field.id]}).subscribe(() => {
                component.toastService.success("Email Inviata con successo!");
              })
            });

          }
        }
      ]
    },
    (cliente) => cliente?.ruoliAccessoObject?.find(x => (x.id == 23 || x.ruolo.toLowerCase() == "sanpellegrino") && x.id)
  )
}

function saveRef(field, bottone, campo, Oggetto, api: ApiPathsService, onEnd?: () => void) {
  var tosend = {
    ...field,
    cliente: Oggetto.id,
    ruoliAccesso: field.ruoli.reduce((acc, ruolo) => [...acc, ...RuoliAccesso(ruolo == "AG" ? "Agente" : ruolo)], []),
  }
  console.log("Salva", {field, bottone, campo, Oggetto, tosend});
  api.ClassicPost(`/anagrafica/clienti/referenti/${field.id ? 'update' : 'add'}`, tosend).subscribe(data => {
    if (!field.id) {
      field.id = data.id;
    }
    if (onEnd)
      onEnd();
  })
}

export var SezioniSanpellegrino: Sezione[] = [
  {
    sezione: "Sanpellegrino",
    campi: [
      TabellaDM_NAM("DM", "DM"),
      TabellaDM_NAM("NAM", "NAM"),
      TabellaDM_NAM("Agenti", "Agente")
    ]
  }
]
